import {defineMessages} from 'react-intl'

import controltables from '../api/controltables'

import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "Failed to fetch some data from the server", 
    defaultMessage: "Failed to fetch some data from the server"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onLoadControlTables = dispatch => (err, ct) => {
  if(err){
    dispatch(addNotification(notification))    
    return console.error("Failed to load controltables", err)
  }
  dispatch({type:"control_tables", payload: ct})
}

export default (locale) => (dispatch, getState) => {
  controltables(locale, onLoadControlTables(dispatch))
}



/** WEBPACK FOOTER **
 ** ./app/actions/loadControlTables.js
 **/